import { useMutation } from '@tanstack/react-query';

import { useLocation } from 'reservations/account/providers/ConfigProvider';
import { getBookingEndpoint } from 'reservations/base/constants/endpoints';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { useBookingId } from 'reservations/booking/providers/BookingProvider';
import {
  type BookingMutationResponse,
  BookingMutationResponseSchema
} from 'reservations/booking/types';
import { restClient } from 'utility/restClient';
import type { RequestError } from 'utility/restClient';

export const useCancelBookingMutationV2 = () => {
  const { slug } = useLocation();
  const bookingId = useBookingId();
  const { handleNavigation } = useCustomRouter();
  const { close } = useModal();

  return useMutation<BookingMutationResponse, RequestError>({
    mutationKey: ['CANCEL_BOOKING'],
    mutationFn: async () => {
      const endpoint = getBookingEndpoint(bookingId, 'cancel');
      const response = await restClient.delete(endpoint);

      try {
        return BookingMutationResponseSchema.parse(response);
      } catch (err) {
        console.error('useCancelBookingMutationV2: ', err);
        throw err;
      }
    },
    onSuccess: () => {
      close();
    },
    onError: _error => {
      handleNavigation({ navUrl: `/locations/${slug}/booking/${bookingId}` });
    }
  });
};
